import React, { useEffect, useRef, useState } from 'react';
import ChartExport from '../chartExport/chartExport';
import ChartInfoButton from '../chartInfoButton/chartInfoButton';
import ChartResetButton from '../chartResetButton/chartResetButton';

// styles
import './chartActionsMobile.scss';

interface ChartActionsMobileProps {
  resetButtonDisabled?: boolean;
  onReset: () => void;
  onExport: () => void;
}

const ChartActionsMobile = (props: ChartActionsMobileProps) => {
  const handleReset = () => {
    props.onReset();
  };

  const handleExport = () => {
    props.onExport();
  };

  return (
    <div className="chartactionsmobile d-md-none">
      <ul>
        <li>
          <ChartResetButton onClick={handleReset} disabled={props.resetButtonDisabled} />
        </li>
        <li>
          <ChartInfoButton text="Geben Sie an, ob Sie sich für den Einkommensanteil vor oder nach Steuern interessieren und wählen Sie rechts aus, welches Jahr Sie sich anschauen möchten. Wenn Sie die generierte Grafik herunterladen möchten, klicken Sie bitte auf das Pfeilsymbol links." />
        </li>
        <li>
          <ChartExport onClick={handleExport} />
        </li>
      </ul>
    </div>
  );
};

export default ChartActionsMobile;
